export default __webpack_public_path__ + "static/media/pw_app_desktop_multiple.361bb86c.png";